<template>
  <v-container>
    <!-- Contact -->
    <v-container class="contact">
      <h1>{{ $t("contact_us") }}</h1>
      <v-row>
        <v-col cols="12" lg="6">
          <v-card>
            <p>
              {{ $t("contact_us_text") }}
              <br />
              <a href="mailto:helpdesk@easiscore.cz	?subject=EASI score">{{
                $t("support_email")
              }}</a>
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    language: "Čeština",
    czech: null
  }),
  methods: {
    onLocaleChange() {
      this.$i18n.locale = this.$i18n.locale === "cs" ? "sk" : "cs";
      this.language = this.czech === true ? "Čeština" : "Slovenština";
    }
  }
};
</script>
<style scoped lang="scss">
h1 {
  color: gray;
  margin-bottom: 0.2em;
}
.v-card {
  padding: 2em;
  box-shadow: 0px 0px 18px 0px rgba(209, 209, 209, 1);
}

//Menu styles
.fas {
  margin-right: 1em;
  color: #324c8d;
}
.v-list-item__title.mennuHeader {
  padding: 5px 0;
  font-size: 1em;
  color: #324c8d;
}
.v-toolbar__title {
  a {
    color: white;
    text-decoration: none;
  }
}

@media only screen and (min-width: 200px) and (max-width: 425px) {
  h1 {
    text-align: center;
  }
  .container {
    padding: 16px 5px;
  }
}
</style>
